// import React, { useEffect, useState } from "react";
// import withRouter from "../withRouter";
// import Menu from "../Component/Menu";
// import Header from "../Component/Header";
// import Footer from "../Component/Footer";
// import { Link } from "react-router-dom";
// import transactionsIcon from "../images/Icons/transaction.png";
// import Credentials from "../Common/Credentials";
// import storeIcon from "../images/Icons/shop.png"
// import mastersIcom from "../images/Icons/generic.png";
// import dashboardIcon from "../images/Icons/dashboard.png";
// import "../NewUI/NewMenu.css"; 

// const ProjectManagement = () => {
//   const [hovered, setHovered] = useState(null);

//   useEffect(() => {
//     Credentials.setSelectedMenu("Project Management");
//   }, []);

//   return (
//     <div>
//       <Header />
//       <Menu />

//       <section className="content-wrapper">
//         <div className="menu-container">
//           <div className="menu-card">
//             <div className="menu-header">
//               {/* Modern Breadcrumb Navigation */}
//               <nav className="menu-breadcrumb">
//                 <Link
//                   to="/index"
//                   className="menu-breadcrumb-link"
//                   onMouseEnter={() => setHovered('home')}
//                   onMouseLeave={() => setHovered(null)}
//                 >
//                   Home
//                 </Link>
//                 <span>/</span>
//                 <span className="menu-breadcrumb-active">
//                   Project Management
//                 </span>
//               </nav>

//               <div className="h-max border-slate-300 bg-white  p-4 rounded-lg menu-content">
//                 <ul className="menu-nav-list">
//                   <li className="menu-nav-item">
//                     <Link
//                       to={{ pathname: "/projectdashboard" }}
//                       state={{ message: "" }}
//                       className="menu-nav-link"
//                     >
//                       <img className="menu-nav-icon" width="25" src={dashboardIcon} />
//                       <div className="mt-1">Dashboard</div>
//                     </Link>
//                   </li>
//                 </ul>

//                 <div className="menu-sections-container">
//                   <div className="menu-section">
//                     <span className="menu-section-title">
//                       <img className="menu-section-icon-masters" src={mastersIcom} />
//                       <span className="menu-section-title-text">Masters</span>
//                     </span>
//                     <ul className="menu-items-list">
//                       <li>
//                         <Link
//                           className="menu-item-link"
//                           to={{ pathname: "/Labours" }}
//                           state={{ message: "" }}
//                         >
//                           Labours
//                         </Link>
//                       </li>
//                     </ul>
//                   </div>

//                   <div className="menu-section menu-transactions-section">
//                     <span className="menu-section-title">
//                       <img className="menu-section-icon" width="20" src={transactionsIcon} />
//                       <span className="menu-section-title-text">Transactions</span>
//                     </span>
//                     <ul className="menu-items-list">
//                       <li>
//                         <Link
//                           className="menu-item-link"
//                           to={{ pathname: "/projects" }}
//                           state={{ message: "" }}
//                         >
//                           Projects
//                         </Link>
//                       </li>
//                       <li>
//                         <Link
//                           className="menu-item-link"
//                           to={{ pathname: "/projectestimation" }}
//                           state={{ message: "" }}
//                         >
//                           Project Estimation
//                         </Link>
//                       </li>
//                       <li>
//                         <Link
//                           className="menu-item-link"
//                           to={{ pathname: "/projectindenting" }}
//                           state={{ message: "" }}
//                         >
//                           Project Indenting
//                         </Link>
//                       </li>
//                     </ul>
//                   </div>

//                   <div className="menu-section">
//                     <span className="menu-section-title">
//                       <img className="menu-section-icon" width="20" src={storeIcon} />
//                       <span className="menu-section-title-text">Store</span>
//                     </span>
//                     <ul className="menu-items-list">
//                       <li>
//                         <Link
//                           className="menu-item-link"
//                           to={{ pathname: "/projectstoretable" }}
//                           state={{ message: "" }}
//                         >
//                           Store
//                         </Link>
//                       </li>
//                     </ul>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       <Footer />
//     </div>
//   );
// };

// export default withRouter(ProjectManagement);





import React from 'react';
import {
  FolderLock,
  ArrowRightLeft,
  FileText,
  ChevronRight,
  Blocks,
  Ruler,
  Tag,
  Palette,
  Layers,
  ShoppingBag,
  Wrench,
  DollarSign,
  Boxes,
  ClipboardCopy,
  AlertTriangle,
  FolderSync,
  TrendingDown,
  Warehouse,
  Users,
  Building2,
  Truck,
  Grid,
  Handshake,
  Calculator,
  ShieldUser
} from 'lucide-react';
import path from 'path-browserify';
import withRouter from '../withRouter';
import Footer from '../Component/Footer';
import { Backdrop } from '@mui/material';
import Header from '../Component/Header';
import Menu from '../Component/Menu';
import { theme, transactionFrom } from '../Common/Credentials';
import { Link, useNavigate } from 'react-router-dom';
import Breadcrumb from '../NewUI/NewComponents/Breadcrumb';
import { use } from 'react';
import Layout from '../Component/Layout';

const ProjectManagement = () => {
  const navigate = useNavigate();
  // Structure mapping matching the image exactly
  const newsections =  theme === "modern" ? [
    {
      title: 'Masters',
      subtitle: 'Resource registries',
      icon: Blocks,
      iconColor: 'tw-bg-green-100 tw-text-green-600 tw-border-green-200',
      items: [
        { id: 'labours', label: 'Labours', desc: 'Contract worker wage logs', icon: Users, brandStyle: 'tw-bg-purple-50 hover:tw-bg-purple-100 tw-text-purple-700', path: '/labours', brandColor: '#7C3AED' },
      ]
    },
    {
      title: 'Transactions',
      subtitle: 'Corporate infrastructure activities',
      icon: ArrowRightLeft,
      iconColor: 'tw-bg-amber-100 tw-text-amber-600 tw-border-amber-200',
      items: [
        { id: 'projects', label: 'Projects', desc: 'Active structural buildings & investments', icon: Building2, brandStyle: 'tw-bg-blue-50 hover:tw-bg-blue-100 tw-text-blue-700', path: '/projects', brandColor: '#3B82F6' },
        { id: 'projest', label: 'Project Estimation', desc: 'Pre-requisite structural material estimates', icon: Calculator, brandStyle: 'tw-bg-amber-50 hover:tw-bg-amber-100 tw-text-amber-707', path: '/projectestimation', brandColor: '#F59E0B' },
        { id: 'projind', label: 'Project Indenting', desc: 'Site material indent requisitions', icon: ClipboardCopy, brandStyle: 'tw-bg-violet-50 hover:tw-bg-violet-100 tw-text-violet-700', path: '/projectindenting', brandColor: '#8B5CF6' }
      ]
    },
    {
      title: 'Store',
      subtitle: 'On-site logistics yards',
      icon: Warehouse,
      iconColor: 'tw-bg-blue-100 tw-text-blue-600 tw-border-blue-200',
      items: [
        { id: 'store', label: 'Store', desc: 'Material logs on active building yards', icon: Warehouse, brandStyle: 'tw-bg-indigo-50 hover:tw-bg-indigo-100 tw-text-indigo-700', path: '/projectstoretable', brandColor: '#6366F1' }
      ]
    }
  ]:[
    {
      title: 'Masters',
      subtitle: 'Resource registries',
      icon: Blocks,
      iconColor: 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]',
      items: [
        { id: 'labours', label: 'Labours', desc: 'Contract worker wage logs', icon: Users, brandStyle: 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]', path: '/labours', brandColor: '#4d4d4d' },
      ]
    },
    {
      title: 'Transactions',
      subtitle: 'Corporate infrastructure activities',
      icon: ArrowRightLeft,
      iconColor: 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]',
      items: [
        { id: 'projects', label: 'Projects', desc: 'Active structural buildings & investments', icon: Building2, brandStyle: 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]', path: '/projects', brandColor: '#4d4d4d' },
        { id: 'projest', label: 'Project Estimation', desc: 'Pre-requisite structural material estimates', icon: Calculator, brandStyle: 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]', path: '/projectestimation', brandColor: '#4d4d4d' },
        { id: 'projind', label: 'Project Indenting', desc: 'Site material indent requisitions', icon: ClipboardCopy, brandStyle: 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]', path: '/projectindenting', brandColor: '#4d4d4d' }
      ]
    },
    {
      title: 'Store',
      subtitle: 'On-site logistics yards',
      icon: Warehouse,
      iconColor: 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]',
      items: [
        { id: 'store', label: 'Store', desc: 'Material logs on active building yards', icon: Warehouse, brandStyle: 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]', path: '/projectstoretable', brandColor: '#4d4d4d' }
      ]
    }
  ]



  const onSelectItem = (path) => {
    navigate(path);
  }

  return (
    <div>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={transactionFrom === null}
      >
        <div className="menu-backdrop-content">
          <div className="d-flex justify-content-center">
            <i className="menu-backdrop-text">Please set transaction start date in order to continue.</i>
          </div>
          <div className="d-flex justify-content-center">
            <Link to="/settings" className="btn btn-sm menu-backdrop-button">Set</Link>
          </div>
        </div>
      </Backdrop>

      <Layout menu={"projectmanagement"}>
        <div className="menu-container tw-mr-2 tw-ml-4">
          <div
            id="dashboard-content-area"
            className="tw-flex-1  tw-overflow-y-auto tw-bg-transparent tw-pb-4"
          >
            {/* Upper Hero Grid */}
            <div
              id="hero-welcome-banner"
              className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-items-center tw-bg-white tw-rounded-3xl tw-px-8 tw-py-2 tw-border tw-border-slate-200/80 tw-shadow-[0_12px_40px_rgba(0,0,0,0.02)] tw-mb-4 tw-relative tw-overflow-hidden"
            >
              {/* Background Blur Shapes */}
              <div className="tw-absolute tw-top-0 tw-right-0 tw-w-96 tw-h-96 tw-bg-blue-50/40 tw-rounded-full tw-blur-3xl -tw-z-10 tw-translate-x-12 -tw-translate-y-12"></div>

              <div className="tw-absolute tw-bottom-0 tw-left-0 tw-w-64 tw-h-64 tw-bg-indigo-50/30 tw-rounded-full tw-blur-3xl -tw-z-10 -tw-translate-x-12 tw-translate-y-12"></div>

              {/* Left Content */}
              <div className="md:tw-col-span-2 tw-text-left tw-space-y-2">
                <Breadcrumb breadcrumbs={[{ name: "Home", path: "/index" }, { name: "Project Management", path: null }]} />
                <h1 className="tw-text-4xl tw-font-extrabold tw-tracking-tight tw-text-slate-900 tw-pt-1">
                  Project Management
                </h1>

                <p className="tw-text-slate-500 tw-font-medium tw-text-[10px] md:tw-text-xs tw-max-w-lg">
                  Monitor real-time infrastructure builds, estimate bulk material weights requirements, assign active contract labour rosters, and authorize indent listings.
                </p>
              </div>

              {/* 3D SVG Security Badging Illustration */}
              <div className="tw-flex tw-justify-center md:tw-justify-end mt-0 tw-relative tw-group">
                {/* <div className="tw-w-40 tw-h-40 tw-relative tw-flex tw-items-center tw-justify-center tw-animate-bounce tw-duration-1000 tw-ease-in-out" style={{ animationDuration: '4.5s' }}> */}
                <div className="tw-w-32 tw-h-32 tw-relative tw-flex tw-items-center tw-justify-center">

                  <div className="tw-absolute tw-bottom-4 tw-w-28 tw-h-3 tw-bg-slate-300/30 tw-rounded-full tw-blur-md"></div>

                  <svg viewBox="0 0 200 200" className="tw-w-32 tw-h-32 tw-drop-shadow-xl">
                    <defs>
                      <linearGradient id="bpGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#1E3A8A" />
                        <stop offset="100%" stopColor="#3B82F6" />
                      </linearGradient>
                    </defs>
                    <rect x="25" y="25" width="150" height="150" rx="16" fill="url(#bpGrad)" />
                    {/* Drafting Grid lines */}
                    <line x1="25" y1="62" x2="175" y2="62" stroke="#60A5FA" strokeWidth="1" opacity="0.3" />
                    <line x1="25" y1="100" x2="175" y2="100" stroke="#60A5FA" strokeWidth="1" opacity="0.3" />
                    <line x1="25" y1="138" x2="175" y2="138" stroke="#60A5FA" strokeWidth="1" opacity="0.3" />
                    <line x1="62" y1="25" x2="62" y2="175" stroke="#60A5FA" strokeWidth="1" opacity="0.3" />
                    <line x1="100" y1="25" x2="100" y2="175" stroke="#60A5FA" strokeWidth="1" opacity="0.3" />
                    <line x1="138" y1="25" x2="138" y2="175" stroke="#60A5FA" strokeWidth="1" opacity="0.3" />
                    {/* Blueprint structures drawing */}
                    <rect x="50" y="50" width="100" height="100" fill="none" stroke="#FFFFFF" strokeWidth="3" strokeDasharray="4 2" />
                    {/* Construction Crane arm */}
                    <path d="M50 50 L100 100 L150 50" fill="none" stroke="#FBBF24" strokeWidth="4" />
                    <circle cx="100" cy="100" r="8" fill="#FBBF24" />
                  </svg>
                </div>
              </div>
            </div>

            {/* Main Grid */}
            <div
              id="erp-columns-grid"
              className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-4"
            >


              {/* Menus */}
              {newsections.map((section) => {
                // const Icon = section.icon;
                return (
                  <div
                    key={section.title}
                    id="section-col-masters"
                    className="tw-bg-white tw-rounded-3xl tw-border tw-border-slate-200/80 tw-p-6 tw-shadow-[0_8px_30px_rgba(0,0,0,0.015)] tw-text-left tw-flex tw-flex-col hover:tw-shadow-lg tw-transition-shadow tw-duration-300"
                  >
                    <div className="tw-flex tw-items-center tw-gap-4 tw-mb-6 tw-pb-4 tw-border-b tw-border-slate-100">
                      <div
                        className={`tw-w-12 tw-h-12 tw-rounded-2xl tw-flex tw-items-center tw-justify-center tw-border ${section.iconColor}`}
                      >
                        <FolderLock size={22} />
                        {/* <Icon size={22} color={section.iconColor} /> */}
                      </div>

                      <div>
                        <h2 className="tw-text-lg tw-font-extrabold tw-text-slate-800">
                          {section.title}
                        </h2>

                        <p className="tw-text-xs tw-text-slate-400 tw-font-medium tw-my-0">
                          {section.subtitle}
                        </p>
                      </div>
                    </div>

                    <div className="tw-space-y-3 tw-flex-1">
                      {section.items.map((item) => {
                        const Icon = item.icon;

                        return (
                          <button
                            id={`subsection-btn-${item.id}`}
                            key={item.id}
                            onClick={() => onSelectItem(item.path)}
                            className="tw-w-full tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-2 tw-rounded-2xl tw-border tw-border-slate-100 tw-bg-white hover:tw-bg-slate-50 hover:tw-border-slate-300/60 hover:tw-shadow-sm tw-transition-all tw-group tw-duration-200 tw-cursor-pointer tw-text-left"
                          >
                            <div className="tw-flex tw-items-center tw-gap-3.5">
                              <div
                                className={`tw-w-9 tw-h-9 tw-rounded-xl tw-flex tw-items-center tw-justify-center ${item.brandStyle} tw-shrink-0`}
                              >
                                <Icon size={16} color={item.brandColor} />
                              </div>

                              <div>
                                <h4 className="tw-text-sm tw-font-bold tw-text-slate-700 group-hover:tw-text-blue-600 tw-transition-colors">
                                  {item.label}
                                </h4>

                                {/* <p className="tw-text-[10px] tw-text-slate-400 tw-font-medium tw-mt-0.5 tw-mb-0">
                    {item.desc}
                  </p> */}
                              </div>
                            </div>

                            <ChevronRight
                              size={16}
                              className="tw-text-slate-300 group-hover:tw-text-blue-500 group-hover:tw-translate-x-0.5 tw-transition-all"
                            />
                          </button>
                        );
                      })}
                    </div>
                  </div>)
              }
              )}
            </div>

          </div>
        </div>
      </Layout>

    </div>
  );
}
export default withRouter(ProjectManagement);